module.exports = __webpack_public_path__ + "cuttingLineSlideLeft.webp?a5e0de89a7225686bb42a9680f2871ef";